/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import Snackbar from '@molecules/Snackbar';
import { useTranslation } from 'config/i18n';
import { ERRORS_CATEGORIES } from 'constants/errors';
import PropTypes from 'prop-types';
import React from 'react';

const MutationsStatus = ({ loading, error, success }) => {
  const { t } = useTranslation(['common']);
  // console.table(error)
  const [open, setOpen] = React.useState(false);

  let type = 'loading';

  if (error) {
    type = 'error';
  }

  if (success) {
    type = 'success';
  }
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (loading || error || success) {
      setOpen(true);
    }
  }, [loading, error, success]);

  const getMessage = (snackType) => {
    let messageContent = [];

    if (snackType === 'loading') {
      messageContent = [<div>{t('loading')}</div>];
    }

    if (snackType === 'success') {
      messageContent = [<div>{t('success')}</div>];
    }
    if (type === 'error') {
      const {
        graphQLErrors = null,
        message: graphMessage = null,
      } = error || {};

      // If we have a custom message prop, use it
      if (graphQLErrors && graphQLErrors.length > 0) {
        // Handle GraphQL errors
        messageContent = [
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            {graphQLErrors.map((err, index) => {
              let errorMessage = t('sorry.error');

              // Lighthouse 6 no longer sends a category for validation errors.
              const category = err.extensions?.category
                || (err.extensions?.validation ? ERRORS_CATEGORIES.VALIDATION : undefined);

              switch (category) {
                case ERRORS_CATEGORIES.VALIDATION: {
                  const validationMessages = Object.values(
                    err.extensions.validation
                  ).reduce((acc, val) => [...acc, ...val], []);

                  return validationMessages.map((msg, msgIndex) => (
                    <li key={`${index}-${msgIndex}`}>{msg}</li>
                  ));
                }
                case ERRORS_CATEGORIES.AUTHENTICATION:
                case ERRORS_CATEGORIES.BAD_REQUEST:
                  errorMessage = err.message || graphMessage;
                  break;
                default:
                  errorMessage = err.extensions?.debug || err.debugMessage || err.message || graphMessage;
              }

              return <li key={index}>{errorMessage}</li>;
            })}
          </ul>
        ];
      } else {
        messageContent = [<div>{t('sorry.error')}</div>];
      }
    }

    return <div>{messageContent}</div>;
  };

  return (
    <Snackbar
      type={type}
      open={open}
      message={getMessage(type)}
      close={type !== 'loading'}
      autoHideDuration={type !== 'loading' ? 50000 : null}
      onClose={handleClose}
    />
  );
};

MutationsStatus.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.object,
  error: PropTypes.object,
};

MutationsStatus.defaultProps = {
  loading: undefined,
  error: undefined,
  success: undefined,
};

export default MutationsStatus;
